import { Header16, Header24, Header32, Header40, Paragraph16 } from '../styles/typography'
import { SimpleLink } from '../components/atoms/link'
import styled from '@emotion/styled'
import { Footer } from '../components/atoms/footer'
import { Testimonials } from '../sections/Testimonials'
import { NavBar } from '../components/atoms/header'
import { HeroBackground, HeroContent, HeroMainHeader, ImageWrapper } from '../components/atoms/pageHero'
import heroImage from '../assets/images/projects/project3.jpg'
import { Contact } from '../sections/Contact'
import contactImage from '../assets/images/contact.jpg'
import whiteLine from '../assets/images/vertical-line.png'
import { Background, MainContainer, ProfileContainer, ProfileImageWrapper, TextContainer } from '../components/about'
import { useEffect } from 'react'

export function ContactPage() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div>
            <NavBar />
            <HeroBackground>
                <HeroMainHeader>
                    <HeroContent>
                        <img src={whiteLine} style={{ height: '40px' }} />
                        <Header40 style={{ color: '#ffffff' }}>Contact Us</Header40>
                    </HeroContent>
                </HeroMainHeader>
                <ImageWrapper src={contactImage} />
            </HeroBackground>
            <Contact />
            <Footer />
        </div>
    )
}
